
export default {
  name: 'responsive-header-mobile',
  components: {},
  props: [],
  data () {
    return {
      tokenValid: false
    }
  },
  computed: {

  },
  mounted () {
    var acc = document.getElementsByClassName("dropbtn");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  },
  watch: { // function that monitors if variable is token is valid
    tokenValid: function (val) {
      if (val == true){
        this.$router.push(
          {
            path: '/portfolios/'
          }
       )
      }
    } 
  },
  methods: {

  }
}


